import { useContext, useState } from 'react'
import { IonButton, IonCheckbox, IonItem, IonLabel, IonModal, IonToast } from '@ionic/react'
import axios from 'axios'
import { AccessToken, AddedSongs, Backup, BookMark, Fsing, LastBackupTime, SongsHistory, User, UserAudios } from '../global'
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { AddToDrive } from '@mui/icons-material'

function Drive(props) {
 const [user, setUser] = useContext(User)
 const [backupDaily, setBackupDaily] = useContext(Backup)
 const [lastBackupTime, setLastBackupTime] = useContext(LastBackupTime)
 const [accessToken, setAccessToken]  = useContext(AccessToken)

 const [bookMark, dispatch] = useContext(BookMark);
 const [addedSongs, setAddedSongs] = useContext(AddedSongs)
 const [songsHistory, setSongsHistory] = useContext(SongsHistory)
 const [fsing, setFsing] = useContext(Fsing)
 const [userAudios, setUserAudios] = useContext(UserAudios)

 const [listResponse, setListResponse] = useState({})
 const [toast, setToast] = useState('false')

 let toastMessageMap = {
  no_save_file_found: 'No saved data found, Please save first!',
  saved: 'Successfully saved the data! You can load the data anytime by clicking the LOAD button',
  loaded: 'Successfully loaded the data!',
  error_login: 'Some thing went wrong! Please try Logging out and Logging in again',
  logged: 'Successfully logged in. Now click on SAVE button to backup your data in your Google Drive',
  login: 'Please login using the above Google Login button to save/load data',
  backup: 'Your data will be automatically once saved every day, whenever you open the app'
 }

 async function saveData(accessToken, listResponse) {
  props.setAlertsMap((prev) => {
   let dum = { ...prev }
   dum['fetching'] = true
   return dum
  })
  var file = new Blob(
   [
    JSON.stringify({
     bookmarks: bookMark,
     addedSongs: addedSongs,
     songsHistory: songsHistory,
     fsing: fsing,
     userAudios: userAudios,
    }),
   ],
   { type: 'application/json' }
  )
  var metadata = {
   name: 'vaishnavasongsappdata',
   mimeType: 'application/json',
   parents: ['appDataFolder'],
  }
  try {
   var formData = new FormData()
   formData.append(
    'metadata',
    new Blob([JSON.stringify(metadata)], {
     type: 'application/json',
    })
   )
   formData.append('file', file)
   if (listResponse.data && listResponse.data.files) {
    for (let i = 0; i < listResponse.data.files.length; i++) {
     if (listResponse.data.files[i].name === 'vaishnavasongsappdata') {
      await axios.delete(`https://www.googleapis.com/drive/v3/files/${listResponse.data.files[i].id}`, {
         headers: {
            Authorization: 'Bearer ' + accessToken,
         }
      })
     }
    }
   }
    await axios({
      method: 'post',
      url: 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id',
      headers: {
       Authorization: 'Bearer ' + accessToken,
       'Content-Type': 'multipart/form-data',
      },
      responseType: 'json',
      data: formData,
     })
   setLastBackupTime((new Date()).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }))
   props.setAlertsMap((prev) => {
      let dum = { ...prev }
      dum['fetching'] = false
      return dum
     })
   return 1
  } catch (error) {
   console.error(error)
   props.setAlertsMap((prev) => {
      let dum = { ...prev }
      dum['fetching'] = false
      return dum
     })
   return -1
  }
 }

 async function loadData(accessToken, listResponse) {
  try {
   for (let i = 0; i < listResponse.data.files.length; i++) {
    let fileContent = {}
    if (listResponse.data.files[i].name === 'vaishnavasongsappdata') {
     props.setAlertsMap((prev) => {
      let dum = { ...prev }
      dum['fetching'] = true
      return dum
     })
     fileContent = await axios.get(`https://www.googleapis.com/drive/v3/files/${listResponse.data.files[i].id}`, {
         headers: {
            Authorization: 'Bearer ' + accessToken,
         },
         params:{
            alt:"media"
         }
      })
     
     if(fileContent.data.addedSongs) setAddedSongs(fileContent.data.addedSongs)
     if(fileContent.data.songsHistory) setSongsHistory(fileContent.data.songsHistory)
     if(fileContent.data.fsing) setFsing(fileContent.data.fsing)
     if(fileContent.data.userAudios) setUserAudios(fileContent.data.userAudios)
     if(fileContent.data.bookmarks) dispatch({ type: "replace", value: fileContent.data.bookmarks });
    
     props.setAlertsMap((prev) => {
      let dum = { ...prev }
      dum['fetching'] = false
      return dum
     })
     break
    }
   }
   return 1
  } catch (error) {
   console.error(error)
   props.setAlertsMap((prev) => {
    let dum = { ...prev }
    dum['fetching'] = false
    return dum
   })
   return -1
  }
 }

 async function listFiles(accessToken){
     try{
      props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['fetching'] = true
         return dum
      })
      let listResponse = await axios.get('https://www.googleapis.com/drive/v3/files', {
         params:{
            spaces:"appDataFolder",
            fields: 'files(id, name, modifiedTime)'
         },
         headers: {
            Authorization: 'Bearer ' + accessToken,
         }
      })
      props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['fetching'] = false
         return dum
      })
      setListResponse(listResponse)
      for (let i = 0; i < listResponse.data.files.length; i++) {
         if (listResponse.data.files[i].name === 'vaishnavasongsappdata') {
            let modifiedTime = new Date(listResponse.data.files[i].modifiedTime).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })
            setLastBackupTime(modifiedTime)
            return listResponse
         }
      }
      return 0
     } catch (error) {
         console.error(error)
         props.setAlertsMap((prev) => {
            let dum = { ...prev }
            dum['fetching'] = false
            return dum
         })
         return -1
      }
 }

 return (
  <div>
   <div style={{ textAlign: 'center' }}>
   
   {!user ? (
   <IonButton style={{textTransform: "none"}} onClick={async()=>{
      try{
         let user_data = await GoogleAuth.signIn()
         let auth_data = await GoogleAuth.refresh()
         delete user_data.authentication
         setUser(user_data)
         setAccessToken(auth_data.accessToken)
         let result = await listFiles(auth_data.accessToken)
         if(result === -1){
            setToast('error_login')
         }
      } catch(err){
         console.error("login failed: ", err)
      }
   }}>
      <AddToDrive style={{marginRight: "10px"}} />
      {props.hindit ? "Google लॉगिन" : "Google Login"}
   </IonButton>):(
   <IonButton style={{textTransform: "none"}} onClick={async()=>{
      try{
         setUser(null)
         setLastBackupTime("Not yet saved")
         setBackupDaily(false)
         await GoogleAuth.signOut();
      } catch(err) {
         console.error("logout failed: ", err)
      }
   }}>
      <AddToDrive style={{marginRight: "10px"}} />
      {props.hindit ? "लोगआउट" : "Logout"} ({user.email})
   </IonButton>)}
   </div>
   <div
    style={{
     display: 'flex',
     justifyContent: 'space-evenly',
     margin: '10px',
    }}
   >
    <IonButton
     onClick={async() => {
      if (!user) {
         setToast('login')
         return
      }
      let result = await listFiles(accessToken)
      if (result === 0) {
         let result2 = await saveData(accessToken, {})
         if (result2 === 1){
            setToast('saved')
         }
         if(result2 === -1){
            setToast('error_login')
         }
      }
      else if(result === -1){
         setToast('error_login')
      }else {
         props.setAlertsMap((prev) => {
            let dum = { ...prev }
            dum['save'] = true
            dum['load'] = false
            return dum
         })
      }
     }}
    >
     {props.hindit ? "बैकअप" : "Backup"}
    </IonButton>
    <IonButton
     onClick={async() => {
      if (!user) {
         setToast('login')
         return
      }
      let result = await listFiles(accessToken)
      if (result === 0) {
         setToast('no_save_file_found')
      }
      else if(result === -1){
         setToast('error_login')
      } else{
         props.setAlertsMap((prev) => {
            let dum = { ...prev }
            dum['save'] = false
            dum['load'] = true
            return dum
         })
      }
     }}
    >
     {props.hindit ? "रिस्टोर" : "Restore"}
    </IonButton>
   </div>
   {user ? <IonItem  color={props.colori}>
    <IonLabel >{props.hindit ? "पिछला बैकअप तिथि: " : "Last backup on: "}{lastBackupTime}</IonLabel>
   </IonItem> : null}
   <IonItem lines='none' color={props.colori}>
    <IonCheckbox style={{ fontFamily: `${props.fon}` }} checked={backupDaily} onIonChange={async(e) => {
      if(!e.detail.checked){
         setBackupDaily(false)
      }else{
         if(!user){
            setToast('login')
            return
         }
         let result2 = await listFiles(accessToken)
         if(result2 === -1){
            setToast('error_login')
            return
         }
         props.setAlertsMap((prev) => {
            let dum = { ...prev }
            dum['save'] = false
            dum['load'] = false
            dum['daily'] = true
            return dum
         })
      }
      }}>{props.hindit ? "दैनिक बैकअप (बीटा)" : "Daily Backup (Beta)"}</IonCheckbox>
   </IonItem>
   <IonModal
    isOpen={props.alertsMap['save'] || props.alertsMap['load'] || props.alertsMap['daily']}
    onIonModalDidDismiss={() => {
        props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['save'] = false
         dum['load'] = false
         dum["daily"] = false
         return dum
        })
       }}
    onDidDismiss={() => {
        props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['save'] = false
         dum['load'] = false
         dum["daily"] = false
         return dum
        })
       }}
   >
    <div style={{ margin: '10px', width:"90vw" }}>
     <div
      style={{
       textAlign: 'center',
       fontSize: '20px',
       margin: '10px',
      }}
     >
      {props.alertsMap['daily'] ? "Daily Backup" : props.alertsMap['save'] ? "Backup" : "Restore"}
     </div>

     {props.alertsMap['save'] || props.alertsMap['daily'] ? (
      <div>
       You have last saved your data at {lastBackupTime}. Would you like to
       overwrite that save?
      </div>
     ) : (
      <div>
       You have last saved your data at {lastBackupTime}. Would you like to
       overwrite current local data with that?
      </div>
     )}
     <div
      style={{
       margin: '10px',
       display: 'flex',
       justifyContent: 'space-evenly',
      }}
     >
      <IonButton
       onClick={() => {
        props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['save'] = false
         dum['load'] = false
         dum["daily"] = false
         return dum
        })
       }}
      >
       Cancel
      </IonButton>
      <IonButton
       onClick={async() => {
        props.setAlertsMap((prev) => {
         let dum = { ...prev }
         dum['save'] = false
         dum['load'] = false
         dum["daily"] = false
         return dum
        })
        if (props.alertsMap['save']){
         let result = await saveData(accessToken, listResponse)
         if (result === 1){
            setToast('saved')
         }
         if(result === -1){
            setToast('error_login')
         }
        } else if(props.alertsMap['daily']){
         let result = await saveData(accessToken, listResponse)
         if (result===1){
            setBackupDaily(true)
            setToast('backup')
         }
         if(result === -1){
            setToast('error_login')
         }
        }
        else {
         let result = await loadData(accessToken, listResponse)
            if (result === 1){
               setToast('loaded')
            }
            if(result === -1){
               setToast('error_login')
            }
        }
       }}
      >
       Proceed
      </IonButton>
     </div>
    </div>
   </IonModal>
   <IonToast
    onDidDismiss={() => {
     setToast('false')
    }}
    isOpen={toast !== 'false'}
    message={toastMessageMap[toast]}
    duration={4000}
   ></IonToast>
  </div>
 )
}

export default Drive
